<template>
  <div
    ref="content"
    @click="isAllShow = true"
    :am-content="isAllShow ? 'allShow' : 'show'"
    v-html="content"
    v-click-outside="() => isAllShow = false"
  />
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isAllShow: false
  })
}
</script>

<style lang="scss" scoped>
[am-content] {
  position: absolute;
  height: calc(100% - 12px);
  width: calc(100% - 24px);
  line-height: 20px;
}
[am-content~='show'] {
  overflow: hidden;
}
[am-content~='allShow'] {
  overflow-y: scroll;
  padding-bottom: 12px;
}
</style>
